// ProjectDashboardItem Component
/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import DateUtil from '../../../lib/dateutil.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import app from '../../../app.jsx'
import { POLYMER_GLIDER_CLIENT_IDS } from '../../../../shared/constants'
class ProjectDashboardItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      comments: props.activity.comments,
      bExpand: false
    }
  }

  static get propTypes () {
    return {
      activity: PropTypes.object,
      onClickPin: PropTypes.func,
      onUpdateComment: PropTypes.func,
      onAddAttachmentToComment: PropTypes.func,
      onDeleteAttachmentFromComment: PropTypes.func,
      onDelete: PropTypes.func,
      onDownload: PropTypes.func,
      onClick: PropTypes.func,
      pinned: PropTypes.bool,
      showdownload: PropTypes.bool,
      comments: PropTypes.string,
      type: PropTypes.string,
      downloadUrl: PropTypes.string,
      bShowReminder: PropTypes.bool,
      onResendMail: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      activity: null,
      onClickPin: null,
      onUpdateComment: null,
      onAddAttachmentToComment: null,
      onDelete: null,
      onDownload: null,
      onClick: null,
      showdownload: false,
      pinned: false,
      comments: '',
      type: '',
      downloadUrl: '',
      bShowReminder: false,
      onResendMail: null
    }
  }

  render () {
    const activity = this.props.activity
    if (activity.type === 'comment') {
      return this._renderComment()
    }

    const typeClass = activity.status ? activity.status.toLowerCase() : ''
    const _className = classnames(
      'project-dashboarditem',
      {},
      `project-dashboarditem_${typeClass}`
    )
    const activityDate = new Date(activity.activityDate)
    let statusText = activity.status

    if (
      activity.type === 'invoice' &&
      activity.status === 'Final' &&
      activity.dueDate
    ) {
      const dueDate = new Date(activity.dueDate)
      statusText = `${IntlUtil.convertMessage(
        'common.dashboard.labelDueOn'
      )} ${DateUtil.getDisplayDay(dueDate)}
      ${DateUtil.getDisplayFullMonth(dueDate)}`
    }

    if (statusText === 'Draft') {
      statusText = IntlUtil.convertMessage('common.dashboard.draftStatus')
    } else if (statusText === 'Open') {
      statusText = IntlUtil.convertMessage('common.dashboard.openStatus')
    } else if (statusText === 'Paid') {
      statusText = IntlUtil.convertMessage('common.dashboard.paidStatus')
    } else if (statusText === 'Approved') {
      statusText = IntlUtil.convertMessage('common.dashboard.approvedStatus')
    } else if (statusText === 'Declined') {
      statusText = IntlUtil.convertMessage('common.dashboard.declinedStatus')
    } else if (statusText === 'Overdue') {
      statusText = IntlUtil.convertMessage('common.dashboard.overdueStatus')
    } else if (statusText === 'Closed') {
      statusText = IntlUtil.convertMessage('common.dashboard.closedStatus')
    }

    let viewTitle = ''
    if (this.props.type === 'purchaseorder') {
      viewTitle = 'View PO'
    } else if (this.props.type === 'expense') {
      viewTitle = 'View Expense'
    } else if (this.props.type === 'invoice') {
      viewTitle = 'View Invoice'
    } else if (this.props.type === 'estimate') {
      viewTitle = 'View Estimate'
    }

    const imageUrl = activity.user ? activity.user.imageUrl : null
    const userName = activity.user ? activity.user.displayName : ''
    const hideEmptyValue = activity.status.toLowerCase() === 'draft'
    const bExpand = this.state.bExpand

    const bShowReminderText = activity.lastReminderDate
      ? DateUtil.isDateEqual(
          activity.lastReminderDate,
          DateUtil.getUTCCurrentDate()
        )
      : false
    const className = `actionpin${this.props.pinned ? ' pinned' : ''}`

    let activityTitle = ''
    if (activity.type === 'estimate') {
      activityTitle = activity.title.replace(
        'Estimate',
        IntlUtil.convertMessage('common.dashboard.labelEstimate')
      )
    } else if (activity.type === 'invoice') {
      activityTitle = activity.title.replace(
        'Invoice',
        IntlUtil.convertMessage('common.dashboard.labelInvoice')
      )
    } else if (activity.type === 'purchaseorder') {
      activityTitle = activity.title.replace(
        'Purchase order',
        IntlUtil.convertMessage('common.dashboard.labelPurchaseOrder')
      )
    } else if (activity.type === 'expense') {
      activityTitle = activity.title.replace(
        'Expense',
        IntlUtil.convertMessage('common.dashboard.labelExpense')
      )
    }

    return (
      <div className={_className} onClick={this._onClick.bind(this)}>
        <div className='itemleft'>
          <div className={className} onClick={this._onClickPin.bind(this)}>
            {this.props.pinned ? (
              <span className='iconcont'>
                <i className='icon icon-project-unpinnormal' />
                <i className='icon icon-project-unpin hover' />
              </span>
            ) : (
              <span className='iconcont'>
                <i className='icon icon-project-pinnormal' />
                <i className='icon icon-project-pin hover' />
              </span>
            )}
          </div>
          <div className='timestamp'>
            {DateUtil.getDisplayDateMonth(activityDate)}
          </div>
        </div>
        <div className='itemright'>
          <div className='itemmain'>
            <div className='colleft'>
              {imageUrl && (
                <div className='avatarholder'>
                  <Avatar imageUrl={imageUrl} title={userName} />
                </div>
              )}
              <div className='infoblck'>
                <div className='infoheader'>
                  <h2 className='title'>{activityTitle}</h2>
                  {this.props.showdownload && (
                    <IconButton
                      title='project.view.titleDownload'
                      tooltipPosition='top'
                      icon='list-attachment'
                      className='estimate'
                      tooltip={viewTitle}
                      target='_blank'
                      href={this.props.downloadUrl}
                      onClick={this._onDownload.bind(this)}
                    />
                  )}
                  {activity.comments && (
                    <IconButton
                      icon='list-notify'
                      size='normal'
                      canHover={false}
                      className='subcriptioninfo'
                      multilingual={false}
                      tooltip={activity.comments}
                      tooltipPosition='top'
                    />
                  )}
                </div>
                <div className='info'>
                  <div className='title'>{activity.subtitle}</div>
                  {statusText && <span className='split' />}
                  {statusText && <label className='status'>{statusText}</label>}
                  {bShowReminderText &&
                    activity.type === 'invoice' &&
                    activity.status === 'Overdue' && <span className='split' />}
                  {bShowReminderText &&
                    activity.type === 'invoice' &&
                    activity.status === 'Overdue' && (
                      <span className='reminderinfo'>
                        <IntlMessage ident='invoice.list.invoiceReminderInfo' />
                      </span>
                    )}
                </div>
              </div>
            </div>
            {!hideEmptyValue && (
              <div className='colright'>
                <h2 className='moneyvalue'>
                  <span className='money'>
                    <PriceText value={activity.total} />
                  </span>
                </h2>
                {this.props.bShowReminder &&
                  !bShowReminderText &&
                  activity.type === 'invoice' &&
                  activity.status === 'Overdue' && (
                    <IconButton
                      icon='common-mailresend'
                      size='big'
                      className='resend'
                      type='error'
                      onClick={this._onResendMail.bind(this)}
                      canHover={false}
                    />
                  )}
              </div>
            )}
            <IconButton
              type='normal'
              size='small'
              className='actionexpand'
              icon={
                bExpand ? 'dashboard-accordionclose' : 'dashboard-accordionopen'
              }
              canHover
              onClick={this._onToggleExpand.bind(this, !bExpand)}
            />
            {bExpand && activity.items.length > 0 && (
              <div className='subitems'>
                {activity.items.map((item, idx) => (
                  <div
                    className={`subitem subitem_${item.status.toLowerCase()}`}
                    key={idx}
                  >
                    <span className='date'>
                      {DateUtil.getDisplayDate(item.activityDate)}
                    </span>
                    <span className='message'>
                      {this._getSubitemMessage(activity, item)}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onClick (ev) {
    ev.preventDefault()

    if (this.props.onClick) {
      this.props.onClick(this.props.activity)
    }
  }

  _onDownload (ev) {
    ev.stopPropagation()
  }

  _onResendMail (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onResendMail) {
      this.props.onResendMail(this.props.activity)
    }
  }

  _onClickDelete (ev) {
    ev.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(this.props.activity)
    }
  }

  _onChangeComment (value) {
    this.setState({ comments: value })
  }

  _onUpdateComment () {
    if (this.props.onUpdateComment) {
      this.props.onUpdateComment(this.props.activity, this.state.comments)
    }
  }

  _onClickPin (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onClickPin) {
      this.props.onClickPin(this.props.activity, this.props.pinned)
    }
  }

  _onToggleExpand (bExpand, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    this.setState({ bExpand: bExpand })
  }

  handleAddAttachmentToComment = (file, message) => {
    if (this.props.onAddAttachmentToComment) {
      this.props.onAddAttachmentToComment(file, message)
    }
  }

  handleDeleteAttachmentFromComment = (index) => {
    if (this.props.onAddAttachmentToComment) {
      this.props.onDeleteAttachmentFromComment(index)
    }
  }

  /* Private Functions */
  _renderComment () {
    const { activity, pinned } = this.props
    const { handleAddAttachmentToComment, handleDeleteAttachmentFromComment } = this
    const activityDate = new Date(activity.activityDate)
    const imageUrl = activity.user ? activity.user.imageUrl : null
    const userName = activity.user ? activity.user.displayName : ''
    const className = `actionpin${this.props.pinned ? ' pinned' : ''}`
    return (
      <div className='project-dashboarditem project-dashboarditem_comment'>
        <div className='itemleft'>
          <div className={className} onClick={this._onClickPin.bind(this)}>
            {pinned ? (
              <span className='iconcont'>
                <i className='icon icon-project-unpinnormal' />
                <i className='icon icon-project-unpin hover' />
              </span>
            ) : (
              <span className='iconcont'>
                <i className='icon icon-project-pinnormal' />
                <i className='icon icon-project-pin hover' />
              </span>
            )}
          </div>
          <div className='timestamp'>
            {DateUtil.getDisplayDateMonth(activityDate)}
          </div>
        </div>
        <div className='itemright'>
          <div className='itemmain'>
            {imageUrl && (
              <div className='avatarholder'>
                <Avatar imageUrl={imageUrl} title={userName} />
              </div>
            )}
            <div className='hovercontent'>
              <IconButton
                type='primary'
                icon='header-upload-delete'
                canHover
                title='project.list.tipView'
                className='act-avatar-delete'
                onClick={this._onClickDelete.bind(this)}
              />
            </div>
            <WysiwygEditor
              placeholder='project.view.yourComment'
              autoFocus={false}
              value={this.state.comments}
              onChange={this._onChangeComment.bind(this)}
              onBlur={this._onUpdateComment.bind(this)}
              fileUploadProps={{
                id: activity.id,
                onUpload: handleAddAttachmentToComment,
                onDelete: handleDeleteAttachmentFromComment,
                documents: activity.commentAttachments || [],
                baseDownloadUrl: `/activity/preview/${app.loggedInId}`,
                uploadUrl: '/api/blob-storage',
                paramsToIncludeDuringUpload: {
                  userId: app.loggedInId,
                  // this env var declared in stone airballoon, defines the path for storing data related to the activity comment attachments
                  clientId: POLYMER_GLIDER_CLIENT_IDS.activityCommentAttachment
                }
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  _getSubitemMessage (activity, item) {
    let messageIdent = ''
    let data = {}
    if (
      activity.type === 'estimate' ||
      activity.type === 'invoice' ||
      activity.type === 'purchaseorder'
    ) {
      messageIdent = `project.view.activity${
        activity.type
      }${item.status.toLowerCase()}`

      if (item.status === 'sendmail') {
        messageIdent = `project.view.activity${activity.type}sendmail`
        if (item.info) {
          data = {
            userName: item.info.userName,
            toEmail: item.info.toEmail
          }
        }
      } else if (item.status === 'resendmail') {
        messageIdent = `project.view.activity${activity.type}resendmail`
        if (item.info) {
          data = {
            userName: item.info.userName,
            toEmail: item.info.toEmail
          }
        }
      } else if (item.status === 'budgetchange') {
        messageIdent = 'project.view.activityPurchaseOrderBudgetChanged'
        data = {
          fromValue: item.info.fromValue || 0,
          toValue: item.info.toValue || 0
        }
      }
    } else if (activity.type === 'expense') {
      messageIdent = 'project.view.activityexpensebooked'
    }

    if (!messageIdent) return ''

    return <IntlMessage ident={messageIdent} value={data} />
  }
}

export default ProjectDashboardItem
